<div class="change-pwd-dialog">
    <bas-change-password></bas-change-password>
</div>